import { ReplicantConfig, FullReplicant, action, createActions, SB, Replicant } from '@play-co/replicant';

const debugPanelActions = createActions(SB.unknown())({
    debugPanel_assign: action((_state, args: { testId: string; bucket: string }, api) => {
        api.abTests.assign(args.testId as never, args.bucket as any);
    }),

    debugPanel_setClockOffset: action((_state, args: { clockOffset: number }, api) => {
        api.setClockOffset(args.clockOffset);
    }),

    debugPanel_getClockOffset: action((_state, _: void, api) => {
        return api.getClockOffset();
    }),
});

type DebugPanelActions = typeof debugPanelActions;

export type DebugPanelReplicant = Replicant<{
    actions: DebugPanelActions;
}>;

export type ReplicantConfigWithDebugPanel<T extends FullReplicant> = ReplicantConfig<
    T & {
        actions: DebugPanelActions;
    }
>;

export function extendReplicantConfigForDebugPanel<T extends FullReplicant>(
    config: ReplicantConfig<T>,
): ReplicantConfigWithDebugPanel<T> {
    return {
        ...config,
        actions: {
            ...config.actions,
            ...debugPanelActions,
        },
    };
}
